export const COMPACT_SCREEN_MAX_WIDTH = 1536;

export const LAYOUT_CONSTANTS = {
  SIDEBAR_COLLAPSED_WIDTH: 56,
  SIDEBAR_EXPANDED_WIDTH: 300,
  SIDEBAR_COMPACT_EXPANDED_WIDTH: 210,
  HISTORY_SIDEBAR_COLLAPSED_WIDTH: 44,
  HISTORY_SIDEBAR_EXPANDED_WIDTH: 300,
  HISTORY_SIDEBAR_COMPACT_EXPANDED_WIDTH: 240,
} as const;

export const getSidebarExpandedWidth = (compact: boolean) =>
  compact
    ? LAYOUT_CONSTANTS.SIDEBAR_COMPACT_EXPANDED_WIDTH
    : LAYOUT_CONSTANTS.SIDEBAR_EXPANDED_WIDTH;

export const getHistorySidebarExpandedWidth = (compact: boolean) =>
  compact
    ? LAYOUT_CONSTANTS.HISTORY_SIDEBAR_COMPACT_EXPANDED_WIDTH
    : LAYOUT_CONSTANTS.HISTORY_SIDEBAR_EXPANDED_WIDTH;
